import { observer } from "mobx-react";
import { useTranslation } from "@/i18n";
import { PreferencesForm } from "@/components/profile-settings/preferences/preferences-form";
import { useMyJobRole } from "@/components/profile-settings/preferences/use-my-job-role";
import { SettingsPageShell } from "@/components/shared/settings-page-shell";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import { START_OF_WEEK_FLAG } from "@/lib/launchdarkly/flags";

/** The intro names exactly the fields on screen. Theme and language always
 *  show; Start of week and Job role are named only while each one renders, so
 *  this reads the same flag and the same `useMyJobRole().shown` those fields do. */
function descriptionKey(startOfWeek: boolean, jobRole: boolean): string {
  if (startOfWeek && jobRole) {
    return "profile_settings.preferences.description_start_of_week_job_role";
  }
  if (startOfWeek) return "profile_settings.preferences.description_start_of_week";
  if (jobRole) return "profile_settings.preferences.description_job_role";
  return "profile_settings.preferences.description";
}

export const ProfilePreferencesPage = observer(function ProfilePreferencesPage() {
  const { t } = useTranslation();
  const showStartOfWeek = useFeatureFlag(START_OF_WEEK_FLAG);
  const myJobRole = useMyJobRole();

  return (
    <SettingsPageShell
      title={t("profile_settings.preferences.title")}
      description={t(descriptionKey(showStartOfWeek, myJobRole.shown))}
    >
      <PreferencesForm myJobRole={myJobRole} />
    </SettingsPageShell>
  );
});
